import Container from '../../components/layout/Container'
import TabPanel from "../../components/navigation/Tab"
import { useState } from 'react'
import SolicitacoesTriagem from "./SolicitacoesTriagem"
import PrivateRoute from '../../auth/private-route'
import EnumEtapasSolicitacaoAcesso from "../../enums/enumEtapasSolicitacaoAcesso"

export default function Triagem(props) {
    const [recarregarTriagens, setRecarregarTriagens] = useState('')

    const tabs = [
        {
            title: "Pendentes de Triagem",
            etapa: [EnumEtapasSolicitacaoAcesso.Enviada],
            itens: SolicitacoesTriagem,
            recarregar: { recarregarTriagens },
            setRecarregar: (value) => setRecarregarTriagens(value)
        },
        {
            title: "Gestores com Acesso",
            etapa: [EnumEtapasSolicitacaoAcesso.Aprovada],
            itens: SolicitacoesTriagem,
            recarregar: { recarregarTriagens },
            setRecarregar: (value) => setRecarregarTriagens(value)
        },
        {
            title: "Gestores com Acesso Negado/Revogado",
            etapa: [EnumEtapasSolicitacaoAcesso.Negada, EnumEtapasSolicitacaoAcesso.Revogada],
            itens: SolicitacoesTriagem,
            recarregar: { recarregarTriagens },
            setRecarregar: (value) => setRecarregarTriagens(value)
        }
    ]

    return (
        <PrivateRoute rolesAllowed={props.roles}>
            <Container
                title="Controle de Acesso TCE-GO">
                <div id="ContainerPage">
                    <TabPanel tabs={tabs} />
                </div>
                <br /><br /><br /><br />
            </Container >
        </PrivateRoute>
    )
}